import { FunctionComponent } from "react";
import { faHubspot, faMicrosoft, faSalesforce } from "@fortawesome/free-brands-svg-icons";
import {
	faCode,
	faPlugCircleBolt,
	faWebhook,
	IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

import ZohoIcon from "@assets/icons/zoho.png";
import { ReactComponent as LemlistIcon } from "@assets/icons/Lemlist_Symbol.svg";
import { ReactComponent as PipedriveIcon } from "@assets/icons/pipedrive.svg";
import { ReactComponent as N8nIcon } from "@assets/icons/n8n.svg";

import { Icon } from "@/components/Icon/Icon";
import { BrandsIcon } from "@/components/BrandsIcon/BrandsIcon";
import { classNames } from "@/utils/classNames";

export type ProviderId =
	| "hubspot"
	| "zoho"
	| "pipedrive"
	| "salesforce"
	| "msdynamics"
	| "lemlist"
	| "mcp"
	| "n8n"
	| "api"
	| "webhooks";

interface ProviderLogoProps {
	provider: ProviderId;
	size?: number;
	className?: string;
}

export const ProviderLogo: FunctionComponent<ProviderLogoProps> = ({
	provider,
	size = 40,
	className,
}) => {
	const dimensions = { width: size, height: size };
	const baseClass = classNames("flex items-center justify-center shrink-0", className);

	if (provider === "hubspot") {
		return (
			<div className={baseClass} style={dimensions}>
				<BrandsIcon
					className="text-[#f57722]"
					icon={faHubspot as IconDefinition}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	if (provider === "zoho") {
		return (
			<div className={baseClass} style={dimensions}>
				<img alt="Zoho CRM" src={ZohoIcon} style={dimensions} />
			</div>
		);
	}

	if (provider === "pipedrive") {
		return (
			<div className={baseClass} style={dimensions}>
				<PipedriveIcon aria-label="Pipedrive" style={dimensions} />
			</div>
		);
	}

	if (provider === "salesforce") {
		return (
			<div className={baseClass} style={dimensions}>
				<BrandsIcon
					className="text-[#00A1E0]"
					icon={faSalesforce as IconDefinition}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	if (provider === "msdynamics") {
		return (
			<div className={baseClass} style={dimensions}>
				<BrandsIcon
					className="text-[#0078d4]"
					icon={faMicrosoft as IconDefinition}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	if (provider === "mcp") {
		return (
			<div className={baseClass} style={dimensions}>
				<Icon
					aria-label="MCP Server"
					className="text-brand-light"
					icon={faPlugCircleBolt}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	if (provider === "n8n") {
		return (
			<div className={baseClass} style={dimensions}>
				<N8nIcon aria-label="n8n" style={dimensions} />
			</div>
		);
	}

	if (provider === "api") {
		return (
			<div className={baseClass} style={dimensions}>
				<Icon
					aria-label="API"
					className="text-brand-light"
					icon={faCode}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	if (provider === "webhooks") {
		return (
			<div className={baseClass} style={dimensions}>
				<Icon
					aria-label="Webhooks"
					className="text-brand-light"
					icon={faWebhook}
					style={{ fontSize: size }}
				/>
			</div>
		);
	}

	return (
		<div className={baseClass} style={dimensions}>
			<LemlistIcon aria-label="Lemlist" style={dimensions} />
		</div>
	);
};
